export default {
  title: "Tags",
  add_tag: "Add tag",
  no_tags: "No tags added yet",
  place_holder: "Type to add o choose previous",
  placeholder_no_tags: "No tags added yet",
};
